import { Box, BoxProps } from '@mui/material'
import { ReactNode, type JSX } from 'react'

export interface TabPanelProps extends BoxProps {
  children: ReactNode
  index: number
  value: number
}

const TabPanel = (props: TabPanelProps): JSX.Element => {
  const { children, value, index, ...other } = props

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </Box>
  )
}

export default TabPanel
